import React, { useState, useEffect } from 'react';
import Layout from './Layout'; // Import the Layout component
import './contactCss.css';
const GOOGLE_MAPS_API_KEY = 'YOUR_GOOGLE_MAPS_API_KEY'; // Replace with your actual API key

const ContactUs = () => {
  const [map, setMap] = useState(null);

  

  const moveToPoint = (lat, lng) => {
    if (map) {
      map.setCenter({ lat, lng });
    }
  };

  return (
    <Layout pageTitle ="Contact Us">
      <div className="container mt-5">
        <div className="col-lg-6 right-col">
          <div className="common-form-style">
            <div className="group-title">Get in touch</div>
            <ul className="touch-list list-unstyled">
              <li className="d-flex">
                <div className="title"><span>Office:</span></div>
                <div className="value"><a href="tel:8889338797">888-933-8797</a></div>
              </li>
              <li className="d-flex">
                <div className="title"><span>Fax:</span></div>
                <div className="value"><span>302-861-3729</span></div>
              </li>
              <li className="d-flex">
                <div className="title"><span>Email:</span></div>
                <div className="value"><a href="mailto:sales@trxservices.com">sales@trxservices.com</a></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container">
        <ul className="locations-list row list-unstyled">
          <li className="loc-item col-md-4">
            <a href="#" onClick={() => moveToPoint(33.86634636206013, -84.47377105665274)} className="loc-link">
              <span className="loc-name">Atlanta</span>
              <span>2727 Paces Ferry Road</span>
              <span>Building One Suite 750</span>
              <span>Atlanta, GA 30339</span>
            </a>
          </li>
          <li className="loc-item col-md-4">
            <a href="#" onClick={() => moveToPoint(40.36523482300439, -74.16746773080902)} className="loc-link">
              <span className="loc-name">Bellworx</span>
              <span>101 Crawfords Corner Road</span>
              <span>Building 4, Suite 4106E</span>
              <span>Holmdel, NJ 07733</span>
            </a>
          </li>
          <li className="loc-item col-md-4">
            <a href="#" onClick={() => moveToPoint(40.067632455834605, -75.31674557314516)} className="loc-link">
              <span className="loc-name">TRX Operations</span>
              <span>18 Elizabeth Street, Suite 110</span>
              <span>West Conshohocken, PA 19428</span>
            </a>
          </li>
        </ul>
      </div>
    </Layout>
  );
};

export default ContactUs;
